/*
 * TimeSpanPlannerPage Messages
 *
 * This contains all the text for the TimeSpanPlannerPage container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.TimeSpanPlannerPage";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Plan a part of the day",
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: "Book time slot",
  },
  thanks: {
    id: `${scope}.thanks`,
    defaultMessage: "Thank you for booking a time slot!",
  },
});
